import type { AxiosError } from "axios";
import { useMemo } from "react";

import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import useApi from "@/hooks/api/useApi";

interface ReferralResponse {
  success: any;
}

export type ReferralRedeemError = AxiosError<{
  detail: string;
  status: number;
  title: string;
}>;

export default function useReferralsRedeem(referrer: string | undefined, enable: boolean = false) {
  const userAddress = useWeb3UserAddress();
  const { path, enabled } = useMemo(
    () => ({
      path: `/superrewards/referrals/redeem/${referrer}/`,
      enabled: Boolean(userAddress) && Boolean(referrer) && enable,
    }),
    [enable, referrer, userAddress]
  );

  const { data, isLoading, isError, error } = useApi<ReferralResponse, ReferralResponse>(
    {
      path,
      useJwt: true,
      forceJwt: true,
    },
    {
      enabled,
      strategy: "fully-cached",
    }
  );

  return {
    data,
    isLoading,
    isError,
    error: error as ReferralRedeemError | undefined,
  };
}
